var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"give-up flex justify-end items-center"},[_c('div',{staticClass:"give-up__button",on:{"click":_vm.handleGiveUp}},[_vm._v(_vm._s(_vm.replay ? '结束复盘' : '放弃考试'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }